import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';
import { Box, Typography } from '@mui/material';

import { clearLoginDetail } from 'state/actions';

const useStyles = makeStyles({
  root: {
    opacity: 0,
    animation: '$fadeOut 15s linear ',
  },
  text: {
    display: 'inline',
    fontSize: '10px',
  },
  status: {
    display: 'inline-block',
    fontSize: '10px',
    fontWeight: 700,
  },
  '@keyframes fadeOut': {
    from: {
      opacity: 1,
    },
    to: {
      opacity: 0,
    },
  },
});

const NavLoginDetail = ({ detail }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      dispatch(clearLoginDetail());
    }, 15000);
  }, [dispatch]);

  return (
    <Box className={classes.root}>
      <Typography className={classes.text}>{t('last_login')}</Typography>
      <Typography className={classes.status}>
        {t(detail.last_login_status ? 'succeeded' : 'failed')}
      </Typography>
      <Typography className={classes.text}>{t('at')}</Typography>
      <Typography className={classes.text}> {detail.last_login_at}</Typography>
    </Box>
  );
};

NavLoginDetail.defaultProps = {
  detail: {},
};

NavLoginDetail.propTypes = {
  detail: PropTypes.object,
};

export default NavLoginDetail;
